import { makeStyles } from "@material-ui/core";

export const useTooltipCommonStyles = makeStyles((theme) => ({
    customTooltip: {
      fontSize: "13px", 
      maxWidth: "100%",
      pointerEvents: "auto",
    },
}));